import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../services/tools/helpers.service';
import { CreditosService } from '../../../../services/creditos.service';

@Component({
  selector: 'modal-fecha-contrato',
  templateUrl: './modal-fecha-contrato.component.html'
})
export class ModalFechaContratoComponent implements OnInit {
  @ViewChild('btnShowModal') btnShowModal: ElementRef;
  @ViewChild('btnClose') btnClose: ElementRef;
  @Output() public updatedFechaContrato : EventEmitter<string> = new EventEmitter;

  @Input() public idCreditos: number = null;
  @Input() public fechaContrato: any = null;

  public loading: boolean = false;

  public contractDate: any = {};

  constructor(
    private helperService: HelpersService,
    private creditosService: CreditosService
  ){
  }

  ngOnInit() {
  }

  public saveFechaContrato(){
    const data = {
      id: this.idCreditos,
      fecha_contrato: this.dateToString(this.contractDate)
    };

    this.loading = true;
    this.creditosService.updateFechaContrato(data).subscribe(
      (response)=>
      {
        const content = response.json().content;
        this.loading = false;
        this.btnClose.nativeElement.click();
        this.updatedFechaContrato.emit(this.dateToString(this.contractDate));
        this.helperService.notification('Fecha actualizada', 'Se ha actualizado exitosamente la fecha de inicio del crédito ', 'success');
      }, error =>
      {
        this.loading = false;
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status === 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public showModal(){
    if (this.fechaContrato ) {
      this.contractDate = this.dateToObj(this.fechaContrato);
    }

    this.btnShowModal.nativeElement.click();
  }

  public dateToObj(laravelDate: any){
    var fecha = new Date(laravelDate); 
    return { year: fecha.getFullYear(), month: (fecha.getMonth()+1), day: fecha.getDate()};
  }

  public dateToString(jsonDate: any){
    let month = (('0' + jsonDate.month).slice(-2));
    let day = (('0' + jsonDate.day).slice(-2));
    return `${jsonDate.year}-${month}-${day} 00:00:00`;
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/components/header-credito/components/modal-fecha-contrato.component.ts